<span> {{title}}</span>
<mat-progress-bar mode="determinate" [value]="currentPreogress"></mat-progress-bar>
